import React, { FunctionComponent } from 'react';
import { SbBlokData, storyblokEditable } from '@storyblok/react';
import classnames from 'classnames';

import { ComparisonTable } from '@savebetter/components';

import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { RichText, RichTextProps } from './RichText';

interface ContentTableHeaders extends SbBlokData {
  imageUrl: string;
  imageAlt: string;
  imageLoading: 'lazy' | 'eager' | undefined;
  headerTitle: string;
  headerIntro: string;
}

interface ContentTableCategoryText extends SbBlokData {
  text: RichTextProps;
}

interface ContentTableCategories extends SbBlokData {
  rowTitle: string;
  descriptions: ContentTableCategoryText[];
}

interface Blok extends PageSectionBlok {
  contentTitle?: string;
  headers: ContentTableHeaders[];
  categories: ContentTableCategories[];
}

interface ContentTableProps extends PageSectionProps {
  blok: Blok;
}

const wrapperClassNames = (hasBackground = true, hasBorder = false, className = ''): string =>
  classnames(
    {
      'bg-black-20': hasBackground,
      'sb-section-has-border-bottom': hasBorder
    },
    className
  );

export const ContentTable: FunctionComponent<React.PropsWithChildren<ContentTableProps>> = ({
  blok,
  sectionClassName
}) => {
  const { hasBackground, hasBorder, contentTitle, headers, categories } = blok;

  const contentCategories = categories.map(category => ({
    rowTitle: category.rowTitle,
    descriptions: category.descriptions.map((description, index) => <RichText key={index} content={description.text} />)
  }));

  return (
    <div className={wrapperClassNames(hasBackground, hasBorder, sectionClassName)} {...storyblokEditable(blok)}>
      {contentTitle && <PageSectionHeader className="mx-5 pt-12">{contentTitle}</PageSectionHeader>}
      <ComparisonTable headers={headers} categories={contentCategories} />
    </div>
  );
};
